/**
 * Webshop categories: the tree, the category editor and the category
 * picker. Fields and SEO labels the product editor shares come from
 * products.shared and products.seo.
 */
export default {
    list: {
        title: 'Categories',
        newCategory: 'New category',
        empty: 'No categories yet.',
        noSlug: '(no slug)',
    },
    edit: {
        newCategory: 'New category',
        created: 'Category created',
        confirmDelete: 'Delete category "{name}"? Children become top-level; products keep their other categories.',
        topLevel: '(Top level)',
        position: 'Position',
        parent: 'Parent',
        menuOrder: 'Menu order',
        menuOrderHint: 'Empty = end of list',
        noImage: 'No image',
        chooseImage: 'Choose image',
        seoIntro: 'Leave a field blank to use the default: the category name for the title, its description for the meta description.',
        seoLocaleFallback: "Blank = use the {locale} value, then the category's own name in this language.",
        socialImageHint: 'Blank = the category image',
        robotsSiteNoindex: 'The website is hidden from search engines, so this category sends noindex,nofollow whatever is set here. Change it in Website → General → Search engines.',
    },
    picker: {
        label: 'Category',
        placeholder: 'Search categories…',
        loadFailed: 'Failed to load categories',
        empty: 'No categories match.',
        draft: '(draft)',
    },
};
